module.exports = __webpack_public_path__ + "img/box-open-full.6416f362.svg";